export const waterBillBundle = {
  titleWaterBill: { ko: "수도 요금", en: "Water Bill", es: "Factura de agua" },
  titleLeakBill: {
    ko: "손실 예상 요금",
    en: "Estimated Loss Cost",
    es: "Costo de pérdida estimada"
  },
  titleRatio: {
    ko: "요금 대비",
    en: "Charge Ratio",
    es: "Proporción de cargos"
  },
  unitCurrency: {
    ko: "원",
    en: "KRW",
    es: "KRW"
  },
  btnLeakAlert: {
    ko: "누수알림",
    en: "Leak Alert",
    es: "Alerta de fuga"
  },
  btnGenerateNotice: {
    ko: "안내문 생성",
    en: "Generate Notice",
    es: "Generar aviso"
  }
}
